import { render, staticRenderFns } from "./free-text.vue?vue&type=template&id=4a16e7b8&scoped=true&"
import script from "./free-text.ts?vue&type=script&lang=ts&"
export * from "./free-text.ts?vue&type=script&lang=ts&"
import style0 from "./free-text.scss?vue&type=style&index=0&id=4a16e7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a16e7b8",
  null
  
)

export default component.exports